export type AboutChapter = {
  id: string;
  label: string;
  headline: string;
  subhead: string;
  body: string[];
};

export const chapters: AboutChapter[] = [
  {
    id: "about",
    label: "About",
    headline: "Product-focused frontend engineer.",
    subhead:
      "Corporate background, product-oriented mindset. I build things people actually use.",
    body: [
      "Years of engineering experience.",
      "Goal oriented implementation.",
      "Currently exploring creative web experiences.",
    ],
  },
  {
    id: "experience",
    label: "Experience",
    headline: "From enterprise systems to single projects.",
    subhead: "Comfortable with complexity and fast iteration.",
    body: [
      "Worked on massive React codebases and smaller projects.",
      "Led development as part of cross-functional teams.",
      "Direct business collaboration to align technical decisions with goals.",
    ],
  },
  {
    id: "approach",
    label: "Approach",
    headline: "AI-Assisted,\nhuman directed.",
    subhead: "Modern tooling for speed,\nexperience for decisions.",
    body: [
      "Years of manual coding translated into conscious AI usage.",
      "Tools accelerate iteration - judgment stays mine.",
      "Architecture and trade-offs require experience, not automation.",
    ],
  },
  {
    id: "services",
    label: "Services",
    headline: "Open for\ncontract work.",
    subhead: "Short-term, long-term, or product-focused collaboration.",
    body: [
      "Web apps.",
      "Landing pages and marketing sites.",
      "Creative web experiences when the project calls for it.",
    ],
  },
  {
    id: "contact",
    label: "Contact",
    headline: "Want to work together?",
    subhead: "Let's talk about your project.",
    body: [],
  },
];

export const CONTACT_HEADLINE = "Let's build\nsomething cool.";
export const CONTACT_SUBHEAD = "Ready to start a project?";
